export default __webpack_public_path__ + "static/media/proj3.6c26aac2.png";